import React from "react";
import { Col, Container, Row } from "reactstrap";

// Shimmer Loading Component
const ImageShimmer = () => {
    return (
        <section className="pb-5 mb-2">
            <Container className="pt-5 mt-5">
                <Row className="rounded-4 overflow-hidden" style={{ background: "#EBF1FA" }}>
                    <Col
                        lg={6}
                        className="d-flex align-items-center justify-content-center custom-height"
                    >
                        <div className="text-start p-4 w-100">
                            {/* Title shimmer */}
                            <div
                                className="shimmer rounded mb-3"
                                style={{
                                    height: "48px",
                                    width: "100%",
                                    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                    backgroundSize: "200% 100%",
                                    animation: "shimmer 1.5s infinite"
                                }}
                            ></div>
                            
                            {/* Subtitle shimmer */}
                            <div
                                className="shimmer rounded mb-3"
                                style={{
                                    height: "32px",
                                    width: "80%",
                                    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                    backgroundSize: "200% 100%",
                                    animation: "shimmer 1.5s infinite"
                                }}
                            ></div>

                            {/* Description shimmer lines */}
                            <div className="my-3">
                                <div
                                    className="shimmer rounded mb-2"
                                    style={{
                                        height: "16px",
                                        width: "100%",
                                        background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                        backgroundSize: "200% 100%",
                                        animation: "shimmer 1.5s infinite"
                                    }}
                                ></div>
                                <div
                                    className="shimmer rounded mb-2"
                                    style={{
                                        height: "16px",
                                        width: "90%",
                                        background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                        backgroundSize: "200% 100%",
                                        animation: "shimmer 1.5s infinite"
                                    }}
                                ></div>
                                <div
                                    className="shimmer rounded"
                                    style={{
                                        height: "16px",
                                        width: "70%",
                                        background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                        backgroundSize: "200% 100%",
                                        animation: "shimmer 1.5s infinite"
                                    }}
                                ></div>
                            </div>
                        </div>
                    </Col>

                    <Col lg={6} style={{ height: "650px", overflow: "hidden" }}>
                        <Row>
                            {/* Three columns of image shimmers */}
                            {[1, 2, 3].map((colIndex) => (
                                <Col xs={4} className="px-2" key={colIndex}>
                                    <div className="d-flex flex-column gap-3 pb-3">
                                        {/* Multiple image placeholders per column */}
                                        {[1, 2, 3].map((imgIndex) => (
                                            <div
                                                key={imgIndex}
                                                className="shimmer w-100 rounded-3"
                                                style={{
                                                    height: "245px",
                                                    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                                                    backgroundSize: "200% 100%",
                                                    animation: "shimmer 1.5s infinite"
                                                }}
                                            ></div>
                                        ))}
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>
            </Container>

            {/* Shimmer animation styles */}
            <style jsx>{`
                @keyframes shimmer {
                    0% {
                        background-position: -200% 0;
                    }
                    100% {
                        background-position: 200% 0;
                    }
                }
                .shimmer {
                    animation: shimmer 1.5s ease-in-out infinite;
                }
            `}</style>
        </section>
    );
};

const Image = ({ data, loading = false }) => {
    
    if (loading) {
        return <ImageShimmer />;
    }
    
    return (
        <>
            <section className="pb-5 mb-2">
    
                <Container className="pt-5 mt-5">
                    <Row className="rounded-4 overflow-hidden" style={{ background: "#EBF1FA" }}>
                        {data && data.length > 0 ? (
                            <>
                                <Col
                                    lg={6}
                                    className="d-flex align-items-center justify-content-center custom-height"
                                >
                                    <div className="text-start p-4">
                                        <h2 className="hero2-title m-0 ps-2" style={{ color: "#132028", fontWeight: "600" }}>
                                            Life at <span style={{ color: "#0777AB" }}>Plexus :</span>
                                            <p>Innovation, Growth, and Collaboration</p>
                                        </h2>
                                        <p className="container space my-3">
                                            At Plexus Technology, we foster a joyful, supportive workplace where employees feel valued. We celebrate festivals like Holi, Diwali, and Navratri, enjoy yearly trips, and host fun activities, making work a fulfilling journey.
                                        </p>
                                    </div>
                                </Col>

                                <Col lg={6} style={{ height: "650px", overflow: "hidden" }}>
                                    <Row>
                                        <Col xs={4} className="px-2">
                                            <div className="slider-container-culture2">
                                                <div className="slider-content-culture2">
                                                    {[...data, ...data].map((imageSet, index) => (
                                                        <div key={index} className="d-flex flex-column gap-3 pb-3">
                                                            {imageSet.map((image, imgIndex) => (
                                                                <img
                                                                    key={imgIndex}
                                                                    src={image}
                                                                    alt={`Image ${imgIndex}`}
                                                                    className="w-100 object-fit-cover object-position-top rounded-3"
                                                                    style={{ height: "245px" }}
                                                                />
                                                            ))}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={4} className="px-2">
                                            <div className="slider-container-culture3">
                                                <div className="slider-content-culture3">
                                                    {[...data.reverse(), ...data].map((imageSet, index) => (
                                                        <div key={index} className="d-flex flex-column gap-3 pb-3">
                                                            {imageSet.map((image, imgIndex) => (
                                                                <img
                                                                    key={imgIndex}
                                                                    src={image}
                                                                    alt={`Image ${imgIndex}`}
                                                                    className="w-100 object-fit-cover object-position-top rounded-3"
                                                                    style={{ height: "245px" }}
                                                                />
                                                            ))}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>

                                        <Col xs={4} className="px-2">
                                            <div className="slider-container-culture2">
                                                <div className="slider-content-culture2">
                                                    {[...data, ...data].map((imageSet, index) => (
                                                        <div key={index} className="d-flex flex-column gap-3 pb-3">
                                                            {imageSet.map((image, imgIndex) => (
                                                                <img
                                                                    key={imgIndex}
                                                                    src={image}
                                                                    alt={`Image ${imgIndex}`}
                                                                    className="w-100 object-fit-cover object-position-top rounded-3"
                                                                    style={{ height: "245px" }}
                                                                />
                                                            ))}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </>
                        ) : (
                            <Col xs={12} style={{ height: "650px", overflow: "hidden" }}>
                                <p className="text-center p-5"></p>
                            </Col>
                        )}
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default Image;